<template>
    <div class="pcr-establishment-informations">
        <div v-if="establishment">
            <div class="tab-contextual-button">
                <el-dropdown trigger="click">
                    <el-button @click.stop>Actions <i class="fa fa-caret-down" aria-hidden="true"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.viewer">
                            <div @click="goToFolder">Visionner le dossier</div>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                            <div @click="showMoveModal = true">Déplacer l'établissement</div>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="establishment.IsAccessibleByAdmins = true && $currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                            <el-tooltip placement="top" content="Rendre ce dossier non visible par les administrateurs de la plateforme" effect="light" :open-delay="300" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                                <div @click="setAccess(false)">
                                    Rendre confidentiel
                                </div>
                            </el-tooltip>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="establishment.IsAccessibleByAdmins = false && $currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                            <el-tooltip placement="top" content="Rendre ce dossier visible par les administrateurs de la plateforme" effect="light" :open-delay="300" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                                <div @click="setAccess(true)">
                                    Rendre visible
                                </div>
                            </el-tooltip>
                        </el-dropdown-item>
                        <el-dropdown-item v-show="!editing" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                            <div @click="startEdit">Editer l'établissement</div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            
            <move-establishment-modal :visible.sync="showMoveModal" :establishment-id="establishmentId"></move-establishment-modal>
            <set-access-establishment-modal :visible.sync="showSetAccessModal" :establishment-id="establishmentId" :is-accessible="isAccessible"></set-access-establishment-modal>
    
            <ck-form ref='ck-form' label-position="top" :read-only="!editing">
                <el-row :gutter="12">
                    <el-col :span="12">
                        <ck-informations label="Identifiant" :display="establishment.EstablishmentId"></ck-informations>
                    </el-col>
                    <el-col :span="12">
                        <ck-informations label="Date de création" :display="$humanize(establishment.CreationDate)"></ck-informations>
                    </el-col>
                </el-row>
                
                <el-row :gutter="12">
                    <el-col :span="12">
                        <ck-informations label="Nombre de groupe" :display="establishment.GroupCount"></ck-informations>
                    </el-col>
                    <el-col :span="12">
                        <ck-informations label="Nombre d'utilisateur" :display="establishment.UserCount"></ck-informations>
                    </el-col>
                </el-row>
    
                <el-row :gutter="12">
                    <el-col :span="24">
                        <ck-form-item label="Etablissement" :display="establishment.Name">
                            <el-input v-model="establishment.Name" auto-complete="off" type="text"></el-input>
                            <ck-validator :validators="{ validator: $ckValidator.required, model: establishment.Name, trigger: 'change' }">
                                Veuillez indiquer le nom de l'établissement partenaire
                            </ck-validator>
                        </ck-form-item>
                    </el-col>
                </el-row>
    
                <el-row :gutter="12">
                    <el-col :span="12">
                        <ck-form-item label="Type d'établissement" :display="establishment.Type">
                            <el-input v-model="establishment.Type" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                    <el-col :span="12">
                        <ck-form-item label="Statut de l'établissement" :display="establishment.Status">
                            <el-input v-model="establishment.Status" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                </el-row>
    
                <el-row :gutter="12">
                    <el-col :span="12">
                        <ck-form-item label="Numéro de SIREN" :display="establishment.SIREN">
                            <el-input v-model="establishment.SIREN" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                    <el-col :span="12">
                        <ck-form-item label="Numéro de SIRET" :display="establishment.SIRET">
                            <el-input v-model="establishment.SIRET" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                </el-row>
    
                <el-row :gutter="12">
                    <el-col :span="12">
                        <ck-form-item label="Addresse" :display="establishment.Address">
                            <el-input v-model="establishment.Address" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                    <el-col :span="12">
                        <ck-form-item label="Complément d'adresse" :display="establishment.AddressComp">
                            <el-input v-model="establishment.AddressComp" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                </el-row>
    
                <el-row :gutter="12">
                    <el-col :span="12">
                        <ck-form-item label="Code postal" :display="establishment.ZipCode">
                            <el-input v-model="establishment.ZipCode" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                    <el-col :span="12">
                        <ck-form-item label="Ville" :display="establishment.City">
                            <el-input v-model="establishment.City" auto-complete="off" type="text"></el-input>
                        </ck-form-item>
                    </el-col>
                </el-row>
                
                <el-row :gutter="12">
                    <el-col :span="24">
                        <ck-form-item label="Information de contact" :display="$linebreakToBR(establishment.ContactInformations)">
                            <el-input v-model="establishment.ContactInformations" auto-complete="off" type="textarea" autosize></el-input>
                        </ck-form-item>
                    </el-col>
                </el-row>
    
                <div v-show="editing">
                    <div class="pull-right">
                        <el-button type="default" @click="cancelEdit" native-type="submit">Annuler</el-button>
                        <el-button type="primary" @click="endEdit" native-type="submit">Enregistrer</el-button>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </ck-form>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default Vue.component('establishment-informations', {
    props: {
        establishmentId: {
            default: () => 0
        }
    },
    data() {
        return {
            refreshing: false,
            establishment: null,
            tmpEstablishment: null,
            editing: false,
            showMoveModal: false,
            showSetAccessModal: false,
            isAccessible: false
        }
    },
    mounted: function () {
        this.refresh();
        
        this.$root.$on('pcr_update_data', () => {
            this.refresh();
        });
    },
    methods: {
        refresh() {
            if (!this.refreshing) {
                this.refreshing = true;

                this.$http.get('/api/establishment/' + this.establishmentId).then((response) => {
                    this.establishment = response.data;
                    this.refreshing = false;
                });
            }
        },
        setAccess(isAccessible) {
            this.isAccessible = isAccessible;
            this.showSetAccessModal = true;
        },
        startEdit(e) {
            e.preventDefault();

            this.tmpEstablishment = _.cloneDeep(this.establishment);

            this.editing = true;
        },
        cancelEdit(e) {
            e.preventDefault();

            this.establishment = this.tmpEstablishment;
            this.tmpEstablishment = null;

            this.editing = false;
        },
        endEdit(e) {
            e.preventDefault();
            this.$refs['ck-form'].validate((valid) => {
                if (valid) {
                    this.$http.post('/api/establishment/' + this.establishmentId, this.establishment).then((response) => {
                        this.$swal({
                            type: 'success',
                            title: 'Sauvegarder',
                            text: 'Vos modifications ont bien été sauvegardées'
                        }).then(() => {

                        });

                        this.refresh();
                        this.tmpEstablishment = null;
                        this.editing = false;
                        this.$root.$emit('pcr_update_tree');
                    });
                }
                else {
                    this.$swal({
                        type: 'error',
                        title: 'Formulaire invalide',
                        html: 'Veuillez vérifier les informations du formulaire.'
                    });
                }
            });
        },
        goToFolder() {
            window.location = `/etablissement/${this.establishmentId}`;
        }
    },
    watch: {
        establishmentId(val) {
            if (val) {
                this.refresh();
            }
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/establishment/establishment-informations.vue